import { Button, DescriptionsItem } from 'fave-ui';
import SummaryCard from '../../../components/SummaryCard';
import { useElementIdContext } from './elementId';
import { useFavePassOutletSummary } from '../../../services/FavePass';

type OutletSummaryProps = {
  favePassId: number;
  onLinkedOutletsClicked: () => void;
};

const OutletSummary = ({
  favePassId,
  onLinkedOutletsClicked,
}: OutletSummaryProps) => {
  const { data: outletSummaryData } = useFavePassOutletSummary({
    favePassId,
  });
  const { btnViewLinked } = useElementIdContext();
  const descriptionItems = [
    {
      key: '1',
      label: 'Linked',
      children: outletSummaryData?.linked_outlets,
    },
    {
      key: '2',
      label: 'Active',
      children: outletSummaryData?.active_linked_outlets,
    },
    {
      key: '3',
      label: 'Inactive',
      children: outletSummaryData?.inactive_linked_outlets,
    },
  ];

  return (
    <>
      <SummaryCard
        title={'Fave Pass Outlet Summary'}
        colon={false}
        column={3}
        endSideContent={
          <Button
            data-id={btnViewLinked}
            type="link"
            onClick={onLinkedOutletsClicked}
          >
            Linked Outlets
          </Button>
        }
      >
        {descriptionItems.map(item => (
          <DescriptionsItem {...item} key={item.key} />
        ))}
      </SummaryCard>
    </>
  );
};

export default OutletSummary;
